"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_window_scroll_top_1 = require("@opten/dom/get-window-scroll-top");
function scrollTo(distance, animationFunction, duration, wrapper) {
    if (animationFunction === void 0) { animationFunction = function (t, b, c, d) {
        return c * t / d + b;
    }; }
    if (duration === void 0) { duration = 300; }
    if (wrapper === void 0) { wrapper = window; }
    var start = get_window_scroll_top_1.default();
    var timeStart;
    var timeElapsed;
    if (wrapper instanceof HTMLElement) {
        start = wrapper.scrollTop;
    }
    requestAnimationFrame.call(window, function (time) {
        timeStart = time;
        loop(time);
    });
    function loop(time) {
        timeElapsed = time - timeStart;
        if (wrapper instanceof Window) {
            wrapper.scrollTo(0, animationFunction(timeElapsed, start, distance, duration));
            if (timeElapsed < duration) {
                requestAnimationFrame.call(window, loop);
            }
            else {
                wrapper.scrollTo(0, start + distance);
            }
        }
        else {
            wrapper.scrollTop = animationFunction(timeElapsed, start, distance, duration);
            if (timeElapsed < duration) {
                requestAnimationFrame.call(window, loop);
            }
            else {
                wrapper.scrollTop = start + distance;
            }
        }
    }
}
exports.default = scrollTo;
